var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPatchDetails(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 24V22H27.8989A4.9678 4.9678 0 0 0 27.167 20.2471L28.657 18.7571L27.243 17.3431L25.753 18.8331A4.9678 4.9678 0 0 0 24 18.1011V16H22V18.1011A4.9678 4.9678 0 0 0 20.2471 18.8331L18.7571 17.3431L17.3431 18.7571L18.8331 20.2471A4.9678 4.9678 0 0 0 18.1011 22H16V24H18.1011A4.9678 4.9678 0 0 0 18.8331 25.7529L17.3431 27.2429L18.7571 28.6569L20.2471 27.1669A4.9678 4.9678 0 0 0 22 27.8989V30H24V27.8989A4.9678 4.9678 0 0 0 25.7529 27.1669L27.2429 28.6569L28.6569 27.2429L27.1669 25.7529A4.9678 4.9678 0 0 0 27.8989 24ZM23 26A3 3 0 1 1 26 23A3.0033 3.0033 0 0 1 23 26Z",
    stroke: "#222222",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 27L10.8 25.2A9 9 0 0 1 6 17.3V4H26V14",
    stroke: "#222222",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatchDetails);
export default __webpack_public_path__ + "static/media/patch-details.49a0374c455fc7bf5bdda03f91d10600.svg";
export { ForwardRef as ReactComponent };